export default __webpack_public_path__ + "static/media/Karnatalkla.db1a91ad.svg";